/* eslint-disable node/no-unsupported-features/es-syntax */
import { lazy, ReactNode } from 'react';

import config from '@core/config';

export const componentLoader = (componentName: string, fallbackComponent?: ReactNode) => {
  return lazy(() =>
    import(`@components/tenants/${config.tenantName}/${componentName}.tsx`)
      .catch(() => import(`@components/tenants/${config.tenantName}/${componentName}/index.ts`))
      .catch(() => import(`@components/shared/${componentName}.tsx`))
      .catch(() => import(`@components/shared/${componentName}/index.ts`))
      .catch(() => ({
        default: () => fallbackComponent || null
      }))
  );
};
